// @generated
// This file was automatically generated and should not be edited.
// Run `dev generate pipeline-frontend` to regenerate.

/* eslint-disable unused-imports/no-unused-imports */

// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {ColumnTypeValidationFlag} from 'data-frames/util/validateColumnType';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {LeafType} from 'data-types/benchling-type-def/BenchlingTypeDef';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {PipelineStepDataKind, PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {PipelineStepShape} from 'pipelines/StepShapeUtils';

export const CREATE_ENTITIES_STEP_SHAPES = [
  {
    stepType: PipelineStepType.CREATE_ENTITIES,
    isDeprecated: false,
    version: 0,
    inputDataShapes: {
      'Input dataset': {
        systemName: 'Input dataset',
        displayName: 'Input dataset',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      }
    },
    outputDataShapes: {
      Outputs: {
        systemName: 'Outputs',
        displayName: 'Outputs',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      },
      Errors: {
        systemName: 'Errors',
        displayName: 'Errors',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: false
      }
    },
    config: {
      schemaId: {
        kind: 'domain',
        required: true,
        types: [
          'ENTITY_SCHEMA'
        ]
      },
      folderId: {
        kind: 'domain',
        required: true,
        types: [
          'FOLDER'
        ]
      },
      namingStrategy: {
        kind: 'enum',
        required: true,
        choices: [
          'NEW_IDS',
          'IDS_FROM_NAMES',
          'DELETE_NAMES',
          'SET_FROM_NAME_PARTS',
          'REPLACE_NAMES_FROM_PARTS',
          'KEEP_NAMES',
          'REPLACE_ID_AND_NAME_FROM_PARTS'
        ]
      },
      columnMapping: {
        kind: 'columnMapping',
        required: true,
        fields: {
          name: {
            kind: 'columnReference',
            required: false,
            inputDataName: 'Input dataset',
            allowMissingColumn: false,
            validationOptions: null
          },
          aliases: {
            kind: 'array',
            required: false,
            elementSpec: {
              kind: 'columnReference',
              required: true,
              inputDataName: 'Input dataset',
              allowMissingColumn: false,
              validationOptions: null
            }
          },
          schemaFields: {
            kind: 'schemaFields',
            required: true,
            rowSourceField: 'schemaId',
            surfaceFieldRequiredness: true
          }
        }
      }
    }
  }
] as const satisfies ReadonlyArray<PipelineStepShape>;
